export default __webpack_public_path__ + "static/media/logo-white.00af9bfc.svg";